import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  routes: [
    { path: '/', redirect: '/login' },
    { path: '/login', component: () => import( '../components/views/Login.vue') },
    {
      path: '/home',
      redirect: '/console',
      component: () => import( '../components/common/Home.vue'),
      children: [
        {
          path: '/console',
          name: 'console',
          component: () => import( '../views/console/index.vue'),
          meta: {
            title: '控制台',
            requiresAuth: true
          }
        },
        {
          path: '/message',
          name: 'message',
          component: () => import( '../views/message/message.vue'),
          meta: { title: '短信记录' }
        },
        {
          path: '/spss',
          name: 'spss',
          component: () => import( '../views/message/spss.vue'),
          meta: { title: '统计分析' }
        },
        {
          path: '/appKey',
          name: 'appKey',
          component: () => import( '../views/dev/appKey.vue'),
          meta: { title: '应用key' }
        },
        {
          path: '/custList',
          name: 'custList',
          component: () => import( '../views/models/custlist.vue'),
          meta: { title: '客户列表' }
        },
        {
          path: '/modelList',
          name: 'modelList',
          component: () => import( '../views/models/list.vue'),
          meta: { title: '模板列表' }
        }
      ]
    }
  ]
})

// 挂载路由导航守卫

router.beforeEach((to, from, next) => {
  // to 将要访问的路径 from 代表从哪个路径跳转而来 next 是一个函数，表示放行
  // next()  放行    next('/login')  强制跳转

  // if (to.path === '/login') return next()
  // 获取token
  // const tokenStr = window.sessionStorage.getItem('token')
  // if (!tokenStr)  return next('/login')
  next()

})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js